import { render } from "./ProductModal.vue?vue&type=template&id=32ec3ae2"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"
script.render = render

export default script